import { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import { getFileImage } from "../../../../actions/CarrierAgreementMgmt/OfficeSettings";
import MaterialTableEmp from "../../../../components/tables/MaterialTableEmp";
import { fileImageView, noImageFound } from "../atoms/atoms";
import { useGetOfficeImageSection } from "../hooks/useGetOfficeImageSection";
import { OfficeFileImageViewModal } from "../modals/OfficeFileImageViewModal";

import OfficeFileImageView from "./OfficeFileImageView";

const OfficeImageSection = ({ data }) => {
  //Data fetching
  const { data: officeData, isLoading: isFetching } =
    useGetOfficeImageSection();
  const [officeImageData, setOfficeImageData] = useState<any>();

  const [showOfficeFileImages, setShowOfficeFileImages] = useState(false);
  const [, setImageView] = useRecoilState(fileImageView);
  const [, setNoImage] = useRecoilState(noImageFound);
  const [imageName, setImageName] = useState();

  //#region Data fetch
  useEffect(() => {
    if (officeData) {
      setOfficeImageData(
        officeData?.filter((x) => x.officeId === data.officeId)
      );
    }
  }, [officeData]);
  //#endregion

  //#region File image modal
  const onClickFileImage = () => {
    setShowOfficeFileImages(true);
  };
  //#endregion

  //#region Close modal
  const onCloseModal = () => {
    setShowOfficeFileImages(false);
    setNoImage("");
    setImageName(undefined);
  };
  //#endregion

  //#region Image view
  const handleImageView = async (imageName) => {
    setImageName(imageName);
    try {
      getFileImage(imageName).then((content) => {
        if (content.status === 404) {
          setNoImage("ImageNotFound");
        } else {
          const imageBlob = new Blob([content.data], { type: "image/*" });
          const imageUrl = URL.createObjectURL(imageBlob);
          setImageView(imageUrl);
        }
      });
    } catch (error) {}
  };
  //#endregion

  //#region Columns
  var columns = [
    {
      title: "Image Category",
      field: "imageCategoryName",
      render: (rowViewData) => {
        return (
          <div className="font-normal font-sans">
            {rowViewData.imageCategoryName}
          </div>
        );
      },
    },
    {
      title: "Image Label",
      field: "imageLabelName",
      render: (rowViewData) => {
        return (
          <div className="font-normal font-sans">
            {rowViewData.imageLabelName}
          </div>
        );
      },
    },
    {
      title: "Filename",
      field: "fileImageName",
      render: (rowViewData) => {
        // Remove the office code from the fileImageName
        const fileImageName = rowViewData.fileImageName?.replace(
          `${data.officeCode}-`,
          ""
        );

        return (
          <div
            className="font-normal font-sans cursor-pointer underline text-primary"
            onClick={() => {
              onClickFileImage();
              handleImageView(rowViewData.fileImageName);
            }}
          >
            {fileImageName?.split(".").slice(0, -1).join(".")}
          </div>
        );
      },
    },
  ];
  //#endregion

  return (
    <>
      <div>
        <div className="px-8 w-full borderContainer pb-4 bg-white">
          <div className="mt-2"></div>
          <MaterialTableEmp
            columns={columns}
            data={officeImageData}
            isLoading={isFetching}
          />
        </div>
      </div>

      {showOfficeFileImages && (
        <OfficeFileImageViewModal
          showFullView={showOfficeFileImages}
          closeFullView={onCloseModal}
          producerCodeId={0}
        >
          <OfficeFileImageView
            officeImage={officeImageData}
            imageName={imageName}
          />
        </OfficeFileImageViewModal>
      )}
    </>
  );
};

export default OfficeImageSection;
